const HomeIcon = ({ color = '#fff', width = '22', height = '22', className }) => {

    return (
        <svg width={width} height={height} className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 10.5L12 3.5l8.5 7" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M5.5 9.5V19a1 1 0 001 1h4.25v-5a1 1 0 011-1h.5a1 1 0 011 1v5H17.5a1 1 0 001-1V9.5" stroke={color} strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )

};

export default HomeIcon;
